/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2025 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PrintOptionDto, SelectedPrintOptionDto } from '@/api-sdk';
import '@/components/image/fg-image';
import { baseStyles, buttonStyles } from '@/styles';

@customElement('fg-print-option-summary')
export class FgPrintOptionSummary extends LitElement {
  @property({ type: Object })
  option?: PrintOptionDto | SelectedPrintOptionDto;

  render() {
    if (!this.option) {
      return null;
    }

    const { colorCount, position, printTechnique, maxSurface, image } =
      this.option;

    return html`
      ${image
        ? html`
            <fg-image
              alt="${position}"
              height="64"
              src="${image}"
              width="64"
            ></fg-image>
          `
        : nothing}
      <div class="specs">
        <strong class="position">${position}</strong>
        <p class="print-technique-colors">
          ${printTechnique
            ? html`
                ${printTechnique}
              `
            : nothing}
          ${printTechnique &&
          (colorCount === null || (colorCount !== undefined && colorCount > 0))
            ? html`
                -
              `
            : nothing}
          ${colorCount && colorCount > 0
            ? html`
                ${t('labels.colors', { count: colorCount })}
              `
            : colorCount === null
              ? html`
                  ${t('labels.fullColor')}
                `
              : nothing}
        </p>
        ${maxSurface
          ? html`
              <p class="max-surface">${maxSurface}</p>
            `
          : nothing}
        <slot name="suffix"></slot>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      :host {
        display: flex;
        align-items: start;
        gap: 8px;
      }

      fg-image::part(image) {
        background-color: #fff;
        aspect-ratio: 64 / 64;
        object-fit: contain;
      }

      .specs {
        display: flex;
        flex-direction: column;
      }

      .position {
        display: block;
        font-size: 1rem;
        margin-bottom: 5px;
      }

      .print-technique-colors {
        margin-bottom: 2px;
      }
    `,
  ];
}
